import { render, staticRenderFns } from "./TableSwapGroup.vue?vue&type=template&id=2ea6d660&scoped=true"
import script from "./TableSwapGroup.js?vue&type=script&lang=js&external"
export * from "./TableSwapGroup.js?vue&type=script&lang=js&external"
import style0 from "./TableSwapGroup.vue?vue&type=style&index=0&id=2ea6d660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea6d660",
  null
  
)

export default component.exports